<template>
  <a-modal
    :title="hasName ? '创建清单' : '添加联系人'"
    :visible="visible"
    :centered="true"
    :mask-closable="false"
    :width="672"
    wrap-class-name="add-contact-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p class="prompt">
      邮箱与联系人之间请用｜分隔，多组邮箱和联系人信息，请换行添加
    </p>
    <a-form
      ref="form"
      :form="form"
    >
      <max-length-input
        v-if="hasName"
        :value="name"
        :required="true"
        label="名称："
        fieldkey="name"
        placeholder="请输入清单名称"
        @change="handleInputName"
      />
      <a-form-item label="联系人：">
        <div
          v-decorator="['contact', {
            rules: [{
              required: true, message: '请输入'
            }],
            initialValue: contact
          }]"
        >
          <codemirror
            ref="myCm"
            v-model="contact"
            :options="options"
            @input="handleChange"
          />
          <span
            v-if="!contact"
            class="placeholder"
          >example@example.com｜联系人</span>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'
import MaxLengthInput from '@/components/pc/MaxLengthInput'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'

export default {
  name: 'AddContactMoadl',
  components: {
    MaxLengthInput,
    codemirror
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hasName: {
      type: Boolean,
      default: false
    },
    contactid: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      contact: '',
      name: ''
    }
  },

  computed: {
    codemirror () {
      return this.$refs.myCm.codemirror
    },
    options: function () {
      return {
        mode: 'text/x-textile',
        tabSize: 2,
        lineNumbers: true,
        lineWrapping: true,
        extraKeys: { 'Ctrl-Space': 'autocomplete' }
      }
    }
  },

  methods: {
    ...mapActions('edm/editContactList', ['importContact']),

    handleInputName (val) {
      this.name = val
    },
    handleChange (val) {
      this.contact = val
    },
    hide () {
      this.$emit('update:visible', false)
      this.clear()
    },
    clear () {
      this.contact = ''
      this.name = ''
      this.form.resetFields()
    },
    handleOk (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.handleImportContact()
        }
      })
    },
    handleCancel () {
      this.hide()
    },
    async handleImportContact () {
      let params = {
        text: this.contact
      }
      if (this.contactid) {
        params.contactid = this.contactid
      }
      if (this.hasName) {
        params.name = this.name
      }
      let chain = await this.importContact(params)
      chain
        .setForm(this.form)
        .onSuccess((res, raw) => {
          this.hide()
          let { failArr, fail = 0, success = 0 } = res
          let msg = raw.message
          if (fail <= 0 && success > 0) {
            this.$message.success(msg)
          }
          let newFailArr = failArr.split(/↵|\n|\r|\r\n|' | '/g) || []
          if (fail === 0) {
            newFailArr = []
          }
          this.$emit('result', newFailArr)
        })
        .onFail(res => {
          console.log(res)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.prompt {
  height:40px;
  line-height: 40px;
  margin-bottom: 24px;
  padding: 0 24px;
  background:#E8F4FF;
}
::v-deep .ant-form-item-label {
  float: left;
  width: 120px;
  padding-right: 16px;
  label {
    color: #666;
  }
}
::v-deep .ant-form-item-control-wrapper {
  padding-left: 120px;
}
::v-deep .ant-form-item-children {
  display: block;
}
::v-deep .CodeMirror {
  width: 480px;
  height: 322px;
  border: 1px solid #d7d7d7;
  .CodeMirror-line  {
    padding: 0 16px;
  }
}
.placeholder {
  position: absolute;
  top: 4px;
  left: 48px;
  width: 400px;
  color: #D7D7D7;
}
</style>
<style lang="scss">
.add-contact-modal {
  .ant-modal-body {
    padding: 0;
  }
}
.filter-contact-result-modal {
  .ant-modal-confirm-content {
    color: #666;
  }
}
</style>
